module.exports = __webpack_public_path__ + "static/intred-07fe058e6779d20d95fddb83a3366b17.jpg";